<template>
  <v-container style="max-width: 100%; padding: 0">
    <v-row v-if="$route.name !== 'Assigned'" no-gutters dense style="" class="empty-desc-box">
      <!-- <v-col cols="auto"> -->
      <v-col cols="12">
        <v-row :class="isMobile ? 'mt-0' : 'mt-8'">
          <!-- <v-col> -->
          <v-col style="text-align: center">
            <!-- <span class="mb-3 styled-input" style="font-size: 36px; color: white" v-if="selectedCh['chType'] === 'P'">
            <b v-html="greetingText" />
            👋
            <b>{{ $t('privateOnBoardingTitleDescription') }}</b>
            🔒
          </span>
          <span class="mb-3 styled-input" style="font-size: 36px; color: white" v-else>
            <b>{{ $t('workspaceOnBoardingTitleDescription') }}</b>
            🚀
          </span> -->
            <span
              class="mb-3 styled-input"
              :style="
                $vuetify.breakpoint.width < 960 ? 'font-size: 20px; color: white' : 'font-size: 36px; color: white'
              "
              v-if="selectedCh['chType'] === 'P'"
            >
              <b v-html="greetingText" />
              👋
              <!-- <b>{{ $t('privateOnBoardingTitleDescription') }}</b> -->
              <br v-if="$vuetify.breakpoint.width < 960" />
              <b>{{ 'This is a private channel' }}</b>
            </span>
            <span
              class="mb-3 styled-input"
              :style="
                $vuetify.breakpoint.width < 960 ? 'font-size: 20px; color: white' : 'font-size: 36px; color: white'
              "
              v-else
            >
              <b v-html="greetingText" />
              👋
              <!-- <b>{{ $t('workspaceOnBoardingTitleDescription') }}</b> -->
              <br v-if="$vuetify.breakpoint.width < 960" />
              <b>{{ 'This is a team channel' }}</b>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :style="
              $vuetify.breakpoint.width < 960
                ? 'color: #96a7af; text-align: center; font-size: 13px'
                : 'color: #96a7af; text-align: center; font-size: 18px'
            "
          >
            <span v-if="selectedCh['chType'] === 'P'">
              <!-- {{ $t('privateOnBoardingBody') }} -->
              {{ 'You can only access the Tapes in private channels.' }}
              <br />
              {{ 'Record a video message and share it with anyone using a link.' }}
            </span>
            <span v-else>
              <!-- {{ $t('workspaceOnBoardingBody') }} -->
              {{ 'Anyone in the workspace can access the Tapes here by default.' }}
              <br />
              {{ 'Create a Tape, and your teammates will see it immediately.' }}
            </span>
            <!-- <span style="line-height: 200%">
            {{ $t('onboardingGetStarted') }}
          </span> -->
          </v-col>
        </v-row>
        <!-- <v-row v-if="selectedCh['chType'] === 'P'">
        <v-col>
          <v-card class="container-card pa-7" min-width="320" height="220" color="#31434f">
            <span class="card-title">{{ $t('privateOnBoardingStep1Title') }}</span>
            <p class="card-content">{{ $t('privateOnBoardingStep1Description0') }}</p>
            <p class="card-content-green">{{ $t('privateOnBoardingStep1Description1') }}</p>
            <p class="card-footer">{{ $t('privateOnBoardingStep1Description2') }}</p>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="container-card pa-7" min-width="320" height="220" color="#31434f">
            <span class="card-title">{{ $t('privateOnBoardingStep2Title') }}</span>
            <p class="card-content">{{ $t('privateOnBoardingStep2Description0') }}</p>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="container-card pa-7" min-width="320" height="220" color="#31434f">
            <span class="card-title">{{ $t('privateOnBoardingStep3Title') }}</span>
            <p class="card-content">{{ $t('privateOnBoardingStep3Description0') }}</p>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <v-card class="container-card pa-7" min-width="320" height="220" color="#31434f">
            <span class="card-title">{{ $t('workspaceOnBoardingStep1Title') }}</span>
            <p class="card-content">{{ $t('workspaceOnBoardingStep1Description0') }}</p>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="container-card pa-7" min-width="320" height="220" color="#31434f">
            <span class="card-title">{{ $t('workspaceOnBoardingStep2Title') }}</span>
            <p class="card-content">{{ $t('workspaceOnBoardingStep2Description0') }}</p>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="container-card pa-7" min-width="320" height="220" color="#31434f">
            <span class="card-title">{{ $t('workspaceOnBoardingStep3Title') }}</span>
            <p class="card-content">{{ $t('workspaceOnBoardingStep3Description0') }}</p>
          </v-card>
        </v-col>
      </v-row> -->
      </v-col>
    </v-row>
    <v-row v-else no-gutters class="assigned-empty-container">
      <v-col cols="12" class="container-assigned-title-sub mt-2" :style="isMobile ? 'text-align: center' : ''">
        <span class="assigned-sub-title">{{ $t('assignedSubTitle') }}</span>
      </v-col>
      <v-col class="mt-4" cols="auto">
        <span class="assigned-empty-content">{{ $t('assignedEmpty') }}</span>
      </v-col>
    </v-row>
    <v-row v-if="$route.name !== 'Assigned'" no-gutters class="">
      <v-col cols="12" class="mt-12" style="" align="center">
        <v-btn
          dark
          color="rgb(40, 144, 103)"
          elevation="0"
          width="210"
          height="50"
          @click="$emit('startMeeting')"
          :loading="isStartMeetingLoading && !startMeetingEvent"
        >
          <span style="font-size: 15px; font-weight: 500">{{ 'Create a new Tape' }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format, isMobile } from '@/common/lib/strLib'
import { mapGetters } from 'vuex'

export default {
  props: { isStartMeetingLoading: Boolean, startMeetingEvent: String },
  mounted() {
    this.$nextTick(() => {
      this.boxWidth()
      window.addEventListener('resize', this.boxWidth)
    })
    this.boxWidth()
  },
  updated() {
    this.$nextTick(() => {
      this.boxWidth()
    })
  },
  beforeDestroy() {
    this.meetingList = []
    window.removeEventListener('resize', this.boxWidth)
  },
  methods: {
    boxWidth() {
      let containerWidth = document.querySelector('.v-main__wrap').clientWidth - 50
      let emptyBox = document.querySelector('.empty-desc-box')
      let margin = (containerWidth % 275) / 2 + 'px'
      if (emptyBox && window.innerWidth >= 960) {
        emptyBox.style.marginLeft = margin
        emptyBox.style.marginRight = margin
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'selectedCh']),
    greetingText() {
      let content
      try {
        content = this.$t('privateOnBoardingTitleGreeting')
        return format(content, [this.userInfo.userDisplayName || this.userInfo.userFullName])
      } catch (err) {
        console.log(err)
      }
      return content
    },
    isMobile() {
      return isMobile()
    },
  },
}
</script>

<style scoped>
.el-input__inner {
  border: none !important;
}
.styled-input >>> .v-input__slot input {
  max-height: 50px !important;
}
.assigned-sub-title {
  font-size: 20px !important;
  font-weight: 600;
  color: white;
}
.assigned-empty-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(90% + 20px));
  justify-content: center !important;
}
.assigned-empty-content {
  font-size: 16px;
  font-weight: 400;
  color: #96a7af;
}
.container-card {
  border-radius: 25px;
}
.card-title {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin-bottom: 0px;
}
.card-content {
  font-weight: 500;
  font-size: 14px;
  color: #96a7af;
  margin-top: 20px;
  margin-bottom: 0px;
}
.card-content-green {
  font-weight: 500;
  font-size: 14px;
  color: #3ed297;
  margin-bottom: 12px;
}
.card-footer {
  font-weight: 700;
  font-size: 14px;
  color: white;
  margin-bottom: 0px;
}
</style>
